import { render, staticRenderFns } from "./indexAddress.vue?vue&type=template&id=e8aabf18&ref=indexAdress&"
import script from "./indexAddress.vue?vue&type=script&lang=ts&"
export * from "./indexAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports